<template>
    <div >
        <el-carousel :interval="5000" indicator-position="none" :height="screenheight">
            <el-carousel-item v-for="(item, index) in data_list.jrwm_lbtp" :key="index">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="" @click="openweb(item.image_url)">
            </el-carousel-item>
        </el-carousel>

        <div style="width: 1200px; margin: 100px auto;" class="flx jcsb">
            <transition name="el-zoom-in-center">
                <div v-show="dom1_show">
                    <div class="flx fdc">
                        <span style="font-size: 24px; color: rgb(64, 64, 64);">商务合作 &nbsp; <span style="font-size: 16px;"><span style="color: rgb(206, 206, 206);">Business cooperation</span></span></span>
                        <div style="width: 46px;height: 1px; background-color: #555; margin-top: 20px;"></div>
                        <!-- <font class="mt20"><span style="font-size: 16px; color: #FFAD2B;">Cultural Media文化传媒有限公司</span></font> -->
                    </div>

                    <div class="flx aic mt30">
                        <img src="../../assets/lianxiren6.png" style="width: 24px;height: 24px;" alt="">
                        <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 14px; margin-left: 15px;">
                            <span>联系人</span>
                            <span style="margin-left: 15px;">{{data_list.linkman}}</span>
                        </div>
                    </div>
                    <div class="flx aic" style="margin-top: 25px;">
                        <img src="../../assets/youxiang2.png" style="width: 24px;height: 24px;" alt="">
                        <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 14px; margin-left: 15px;">
                            <span>电子邮箱</span>
                            <span style="margin-left: 15px;">{{data_list.email}}</span>
                        </div>
                    </div>

                    <div class="flx aic" style="margin-top: 25px;">
                        <img src="../../assets/emidianhua2.png" style="width: 24px;height: 24px;" alt="">
                        <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 14px; margin-left: 15px;">
                            <span>联系电话</span>
                            <span style="margin-left: 15px;">{{data_list.phone}}</span>
                        </div>
                    </div>

                    <div class="flx aic" style="margin-top: 25px;">
                        <img src="../../assets/daohangdizhi.png" style="width: 24px;height: 24px;" alt="">
                        <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 14px; margin-left: 15px;">
                            <span>联系地址</span>
                            <span style="margin-left: 15px;">{{data_list.address}}</span>
                        </div>
                    </div>
                    <div class="flx aic" style="margin-top: 25px;">
                        <img src="../../assets/weixin.png" style="width: 24px;height: 24px;" alt="">
                        <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 14px; margin-left: 15px;">
                            <span>微信号</span>
                            <span style="margin-left: 15px;">{{data_list.wechat_id}}</span>
                        </div>
                    </div>

                    <div class="flx mt50">
                        <img style="width: 100px; height: 100px;" :src="data_list.xcx_img" alt="">
                        <img class="ml100" style="width: 100px; height: 100px;" :src="data_list.gzh_img" alt="">
                    </div>
                </div>
            </transition>

            <transition name="el-zoom-in-center">
                <div v-show="dom1_show">

                    <div class="tc">给我们留言</div>
                    <div class="flx aic mt30">
                        <div style="width: 60px;">姓名</div>
                        <el-input style="width: 540px;" v-model="name" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="flx aic mt30">
                        <div style="width: 60px;">电话</div>
                        <el-input style="width: 540px;" v-model="phone" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="flx aic mt30">
                        <div style="width: 60px;">邮箱</div>
                        <el-input style="width: 540px;" v-model="email" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="flx aic mt30">
                        <div style="width: 60px;">留言</div>
                        <el-input
                            style="width: 540px;"
                            type="textarea"
                            :rows="5"
                            placeholder="请输入内容"
                            v-model="textarea">
                        </el-input>
                    </div>
                    <el-button style="background-color: #C8161D; width: 230px; color: #fff; margin: 30px 0 0 60px;" @click="tijiao()">立即提交</el-button>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Index4',
    metaInfo: {
        title: '加入上通优选  - 交农一品 | 上海上通优选农业科技发展有限公司',
        meta: [
            { keywords: '交农一品,上通优选,上海上通优选农业科技发展有限公司' },
            { description: '交农一品,隶属于上海上通优选农业科技发展有限公司,秉持三农情怀,为解决我国中小型农产品生产商在品牌运作、市场营销、持续发展方面的困境,特提供品牌赋能、技术支持、市场营销三大助力,为中国一流品质的农产品保驾护航,系为中小型优质农产品生产商提供品牌赋能、销售渠道服务的专业平台' }
        ]
    }, 
    data () {
        return {
            screenheight: '500px',
            data_list: '',
            name: '',
            phone: '',
            email: '',
            textarea: '',
            dom1_show: false,
            screenWidth: null
        }
    },
    methods:{
        getData() {
            this.$post('index.php?s=/api/index/contact_us', {
                wxapp_id: 10001
            })
            .then((res) => {
                if(res.code == 1) {
                    this.data_list = res.data.list;
                }
            }) 
        },
        tijiao() {
            this.$post('index.php?s=/api/index/message', {
                wxapp_id: 10001,
                linkman: this.name,
                phone: this.phone,
                email: this.email,
                content: this.textarea
            })
            .then((res) => {
                if(res.code == 1) {
                    this.$message({
                        offset: 400,
                        message: res.msg,
                        type: 'success'
                    });
                } else {
                    this.$message({
                        offset: 400,
                        message: res.msg,
                        type: 'error'
                    });
                }
            }) 
        },
        openweb(e) {
            if(e) {
                window.open(e)
            }
        },
    },
    watch: {
        screenWidth: {
            handler: function (val, oldVal) {
                if (val*500/1920 < 321.5) {
                    this.screenheight = '321.5px';
                } else {
                    this.screenheight = val*500/1920 + 'px';
                }
            },
        },
    },
    created() {
        this.getData();
    },
    mounted() {
        this.dom1_show = true;
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })()
        }
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/index/index4.vue